import { CircularLoader } from '@modules/common/components/CircularLoader';
import { trackDashboardEvent } from '@modules/dashboard/helpers';
import { useUpdateDashboard } from '@modules/dashboard/hooks/useUpdateDashboard';
import { CloseRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { DashboardViewFragment, UserInfoViewFragment } from 'generated/graphql';

interface DashboardRemoveCollaboratorButtonProps {
  dashboard: Pick<
    DashboardViewFragment,
    'id' | 'editToken' | 'viewToken' | 'version'
  >;
  userToRemove: UserInfoViewFragment;
}

export const DashboardRemoveCollaboratorButton = ({
  dashboard,
  userToRemove,
}: DashboardRemoveCollaboratorButtonProps) => {
  const { updateDashboard, loading: isUpdatingDashboard } =
    useUpdateDashboard();

  const removeCollaborator = async () => {
    await updateDashboard({
      updateRequest: {
        id: dashboard.id,
        editToken: dashboard.editToken ?? '',
        viewToken: dashboard.viewToken ?? '',
        editorsToRemove: [userToRemove.id],
      },
    });
    trackDashboardEvent({
      eventName: 'Dashboard Collaborators Removed',
      dashboardLink: window.location.href,
      collaborators: [{ ...userToRemove, isExisting: true, email: '' }],
    });
  };

  if (isUpdatingDashboard) {
    return <CircularLoader size={24} />;
  }

  return (
    <IconButton onClick={() => removeCollaborator()} title="Remove" edge="end">
      <CloseRounded color="primary" />
    </IconButton>
  );
};
